import type { RootState } from "~/app/store";

export const selectUnitMode = (state: RootState) => state.userPreferences.unitMode;
export const selectSearchDisplayMode = (state: RootState) => state.userPreferences.searchDisplayMode;
